import { Stores } from '../models/Stores';
import { observable } from 'mobx';

export class BaseStore {
    @observable
    stores: Stores;

    constructor(stores: Stores) {
        this.stores = stores;
    }
}



// WEBPACK FOOTER //
// ./src/stores/BaseStore.ts